import { render } from "./EmpGatePassView.vue?vue&type=template&id=37ea1ff4&scoped=true"
import script from "./EmpGatePassView.vue?vue&type=script&lang=js"
export * from "./EmpGatePassView.vue?vue&type=script&lang=js"

import "./EmpGatePassView.vue?vue&type=style&index=0&id=37ea1ff4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ea1ff4"]])

export default __exports__